import React from "react";
import { Alert, Table } from "react-bootstrap";
import PaginationComponent from "../PaginationComponent";
import useMediaQuery from "../../utils/useMediaQuery";

function ContributorsTable({ totalContributors, currentContributors, emptyMessage, t, indexOfFirstContributor, totalContributorsPages, currentContributorsPage, setCurrentContributorsPage }) {
  const isMobile = useMediaQuery("(max-width: 768px)");

  return (
    <div className="mb-5">
      <h5 className="mb-3">{t.contributorsList}</h5>
      {currentContributors.length === 0 ? (
        <Alert variant="info">{emptyMessage}</Alert>
      ) : (
        <div className="table-responsive">
          <Table striped hover responsive>
            <thead>
              <tr>
                <th>#</th>
                <th>{t.name}</th>
              </tr>
            </thead>
            <tbody>
              {currentContributors.map((contributor, index) => (
                <tr key={contributor.id || index}>
                  <td>{indexOfFirstContributor + index + 1}</td>
                  <td>{contributor.name}</td>
                </tr>
              ))}
            </tbody>
          </Table>
        </div>
      )}
      {totalContributorsPages > 1 && (
        <PaginationComponent
          totalPages={totalContributorsPages}
          isMobile={isMobile}
          setCurrentPage={setCurrentContributorsPage}
          currentPage={currentContributorsPage}
          t={t}
          tItemName={t.contributor}
          indexOfFirst={indexOfFirstContributor}
          indexOfLast={indexOfFirstContributor + totalContributors}
          lengthTotal={totalContributors}
        />
      )}
    </div>
  );
}

export default ContributorsTable;


